export default __webpack_public_path__ + "static/media/prelist-default.6240075a.jpg";